import { render } from "./content-filter.vue?vue&type=template&id=45172b6a"
import script from "./content-filter.vue?vue&type=script&lang=js"
export * from "./content-filter.vue?vue&type=script&lang=js"

import "./content-filter.vue?vue&type=style&index=0&id=45172b6a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__